import React, { useEffect, useMemo } from 'react';
import EmojiCard from './EmojiCard';
import VerticalBar from './VerticalBar';
import { Select } from 'antd';
import { useState } from 'react';
import { Tabs } from 'antd';
import images from '../../../themes/appImage'
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { averageMoodLoad, thoughtsLoggedLoad } from '../../../redux/slices/dash.slice';

const { Option } = Select;


const ThoughtChart = ({ orgId, tab }) => {
  let data = moment().month();
  const [month, setMonth] = useState(data)
  const currentDate = new Date();
  const firstDayOfMonth = new Date(Date.UTC(currentDate.getFullYear(), month, 1));
  const lastDayOfMonth = new Date(Date.UTC(currentDate.getFullYear(), month + 1, 0, 23, 59, 59));

  const averageData = {
    logType: "thoughts",
    startDate: firstDayOfMonth.toISOString(),
    endDate: lastDayOfMonth.toISOString(),
    organisation: orgId
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (tab == 2) {
      const payload = {
        month: month,
        organisation: orgId
      }
      dispatch(thoughtsLoggedLoad(payload));
      dispatch(averageMoodLoad(averageData));
    }
  }, [month, dispatch, tab]);

  const mydata = useSelector((state) => state.dashboardReducer) || {};
  const thoughtsData = mydata?.thoughtsData;
  const averageMoodData = mydata?.averageData;
  const currentMonthMean = averageMoodData?.currentMonthMean;
  const percentageChange = averageMoodData?.percentageChange;

  const findNearestKey = (thoughtsData, currentMonthMean) => {
    let nearestKey = null;
    let minDifference = Infinity;

    // Iterate through the keys of thoughtsData
    for (const key in thoughtsData) {
      if (thoughtsData.hasOwnProperty(key)) {
        // Calculate the absolute difference between the currentMonthMean and the value of the key
        const difference = Math.abs(currentMonthMean - thoughtsData[key]);

        // Update nearestKey and minDifference if this key's value is closer to the currentMonthMean
        if (difference < minDifference) {
          nearestKey = key;
          minDifference = difference;
        }
      }
    }

    return nearestKey;
  };

  // Find the nearest key
  const nearestKey = findNearestKey(thoughtsData, currentMonthMean);

  let totalSum = 0;
  for (const key in mydata.thoughtsData) {
    if (key !== "_id") {
      totalSum += mydata?.thoughtsData[key];
    }
  }

  const moodData = useMemo(() => {
    return [
      { percentage: `${(totalSum !== 0 ? (mydata?.thoughtsData.veryPositive / totalSum) * 100 : 0)}`, imageSource: images.veryPositive, altText: "veryPositive" },
      { percentage: `${(totalSum !== 0 ? (mydata?.thoughtsData.positive / totalSum) * 100 : 0)}`, imageSource: images.postive, altText: "positive" },
      { percentage: `${(totalSum !== 0 ? (mydata?.thoughtsData.neutral / totalSum) * 100 : 0)}`, imageSource: images.neutral, altText: "neutral" },
      { percentage: `${(totalSum !== 0 ? (mydata?.thoughtsData.negative / totalSum) * 100 : 0)}`, imageSource: images.negative, altText: "negative" },
      { percentage: `${(totalSum !== 0 ? (mydata?.thoughtsData.veryNegative / totalSum) * 100 : 0)}`, imageSource: images.veryNegative, altText: "veryNegative" }
    ];
  }, [mydata?.thoughtsData]);
  console.log(moodData, "moodData");
  const handleMonthChange = (value) => {
    console.log("the value of month is", value);
    setMonth(value);
  };

  const nearestMood = moodData.find(mood => mood.altText === nearestKey);
  const nearestImageSource = nearestMood ? nearestMood.imageSource : null;
  console.log(nearestKey, nearestImageSource , percentageChange ,"akak"  );

  return (
    <div>
      <div className='flex justify-between lg:flex-col lg:items-center gap-3 w-[100%]'>
        <div className='w-[70%] pb-2'>
          <div className='flex items-center justify-between months-selector'>
            <div></div>
            <div className='w-[100px]'>
            <Select defaultValue={month.toString()} onChange={handleMonthChange}>
              <Option value="0">January</Option>
              <Option value="1">February</Option>
              <Option value="2">March</Option>
              <Option value="3">April</Option>
              <Option value="4">May</Option>
              <Option value="5">June</Option>
              <Option value="6">July</Option>
              <Option value="7">August</Option>
              <Option value="8">September</Option>
              <Option value="9">October</Option>
              <Option value="10">November</Option>
              <Option value="11">December</Option>
            </Select>
            </div>
          </div>
          <div className='flex gap-2 h-[300px] items-end px-[15px] justify-evenly'>
            {moodData.map((mood, index) => (
              <VerticalBar
                key={index}
                barPercentage={Number(mood.percentage) > 100 ? "100%" : Number(mood.percentage) < 18 ? "18%" : (mood.percentage) + "%"}
                textPercentage={Math.floor(Number(mood.percentage)) + "%"}
                imageSource={mood.imageSource}
                altText={mood.altText}
              />
            ))}
          </div>
        </div>
        <div className='w-[30%] flex mb-2'>
          <EmojiCard
            moodImage={nearestImageSource}
            moodDescription={nearestKey}
            percentageChange={percentageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ThoughtChart;
